import styled from 'styled-components';

export const Wrapper = styled.div`
	.MuiButton-root {
		background-color: transparent;
	}
`;

export const PageHeader = styled('div')`
	font-size: 14pt;
	font-weight: 500;
	padding: 10px 0px 10px 0px;
`;

export const StyledControlsWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
